/**
 * Formats an OwaDate offset as UTC(+/-)HH:MM.
 * OwaDate offsets are inverted: UTC+1 is -60 minutes, UTC-8 is +480 minutes.
 */
export function buildShortUtcStringFromMinutesOffset(offset: number): string {
    if (offset === 0) {
        return "UTC";
    }
    
    const hour = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset > 0 ? "-" : "+";
    
    return ("UTC" + sign + hour.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0"));
}
